import axios from "axios";
import { BASE_API_URL } from "../consts";

export interface CategoryItem {
  _id?: string;
  name: string;
  description?: string | null;
  price: number;
  currency: "EUR" | "RSD" | "BAM";
  isAvailable: boolean;
}

export type MenuCategoryType = "contact" | "items" | "meals";

export interface ClientMenuCategory {
  _id: string;
  clientId: string;
  name: string;
  emoji: string;
  description?: string | null;
  type: MenuCategoryType;
  // type === "contact"
  contactPhone?: string | null;
  contactLabel?: string;
  // type === "items"
  items: CategoryItem[];
  currency: "EUR" | "RSD" | "BAM";
  // type === "meals" — empty = all meals enabled for the apartment
  linkedMealIds?: string[];
  showPrices: boolean;
  isActive: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export const getMenuCategories = (clientId: string) =>
  axios.get<ClientMenuCategory[]>(`${BASE_API_URL}/${clientId}/menu-categories`);

export const createMenuCategory = (clientId: string, data: Partial<ClientMenuCategory>) =>
  axios.post<ClientMenuCategory>(`${BASE_API_URL}/${clientId}/menu-categories`, data);

export const updateMenuCategory = (id: string, data: Partial<ClientMenuCategory>) =>
  axios.put<ClientMenuCategory>(`${BASE_API_URL}/menu-categories/${id}`, data);

export const deleteMenuCategory = (id: string) =>
  axios.delete(`${BASE_API_URL}/menu-categories/${id}`);
